module.exports = __webpack_public_path__ + "img/b5.4bc47968.png";